export function getUserIntentPrompt({ userMessage, chattingName }) {
  return `
${getUserIntentPromptContract}

You are Kairos, a website builder.
User name: "${chattingName}"
User message: "${userMessage}"

Return JSON only.
`.trim();
}



export function generateFullPageHtmlCssPrompt({ websiteName, websiteDescription, userRequest }) {
  return `
${generateFullPageHtmlCssPromptContract}
You are Kairos, an AI Website builder.
Website name: "${websiteName}"
Website description: "${websiteDescription}"
User request: "${userRequest}"

Return JSON only.
  `.trim();
}



export function editFullPageHtmlCssPrompt({ userRequest, currentHtml, currentCss }) {
  return `
You are Kairos. Update an existing webpage by editing its HTML and CSS.

User request:
"${userRequest}"

Current HTML (body content only):
${JSON.stringify(currentHtml || "")}

Current CSS:
${JSON.stringify(currentCss || "")}

Return VALID JSON ONLY with EXACT keys:
{
  "html": "<UPDATED HTML (body content only)>",
  "css": "UPDATED CSS"
}

Rules:
- Keep it as a single root wrapper element (e.g. <div class="page">...</div>).
- Do NOT include <html>, <head>, <body>, <script>.
- No <script> tags.
- No inline event handlers like onclick=.
- Preserve existing structure unless user requested layout changes.
- Apply the requested changes accurately.

Important: Never comment code, just pure css and html.

Return JSON only.
  `.trim();
}


export function updateWebsiteMetaPrompt({ currentWebsiteName, currentWebsiteDescription, userRequest, chattingName }) {
  return `
Always return valid JSON with the change requested by the user based on this "${userRequest}":
{
  "newWebsiteName": "string (only if userRequest is changing website name, else return currentWebsiteName)",
  "newWebsiteDescription": "string (only if userRequest is changing website description, else return currentWebsiteDescription)",
  "friendlyResponse": "4-10 words", always address user by "${chattingName}" else use "There".
}

if user is asking for change for both, return new website name and description.

Return JSON only.

You are Kairos, a website builder.

Current Website name: "${currentWebsiteName}"
Current Website description: "${currentWebsiteDescription}"
User request: "${userRequest}"
User's name is "${chattingName}"
  `.trim();
}

export function createWebsiteInfoPrompt({ userRequest, chattingName }) {
  return `
Return JSON with exactly these keys:
- websiteName (short, brandable) and always use spaces if combining names.
- websiteDescription (one sentence)
- friendlyResponse (1 sentence, friendly tone, what you have will do. Always refer to user by their name given by User's name)
- userAction (a short phrased summarizing what the user's action or request was, please use phrases like "You asked for or requested a...")
- kairosAction (a short phrase with details of what AI promp returned from the api call, and plese include a summarized version of what was returned, please use a simple phrase of 4-5 words, please don't use phrases like AI create..., use Kairos did ...)
- Never use Kairos as part of the name.

User request: "${userRequest}"
User's name is "${chattingName}"
  `.trim();
}

export function getComponentsToEditFromAIPrompt({ userMessage, pageSummary, selectorList }) {
  return `
${getComponentsToEditFromAIPromptContract}

You are Kairos, a website builder.

Page summary:
"${pageSummary || ""}"

Available selectors/classes:
${JSON.stringify(selectorList || [])}

User request:
"${userMessage}"

Return JSON only.
`.trim();
}



































const getComponentsToEditFromAIPromptContract = `
Return VALID JSON ONLY:
{
  "editType": "styleEdit | contentEdit | moveComponent | addComponent | removeComponent | globalStyleEdit | Unknown",
  "targetSelectors": [],
  "position": "",
}

Rules:
- editType must be exactly one of:
  styleEdit, contentEdit, moveComponent, addComponent, removeComponent, globalStyleEdit, Unknown
- targetSelectors must be an array of selectors/classes taken from the html page.
- position is only for moveComponent or addComponent if the user mentions before, after, inside, top, bottom, left, right, above, below
- If the request is unclear, return editType="Unknown"
- Use the smallest number of targetSelectors needed
- Use the given html structure to determine the exact components as describe.
`;


const getUserIntentPromptContract = `
Return VALID JSON ONLY:
{
  "userIntent": "Meta | Edit | Regenerate | Unclear | Upcoming",
  "estimatedTokens": 0.00
}

Rules:
- userIntent must be exactly one of:
  1. Meta - if editing website meta
  2. Edit - if editing page code or content
  3. Regenerate - if page regeneration
  4. Unclear - if user message is unclear
  5. Upcoming - if user message is message is random or not actionable
- estimatedTokens must be a number with 2 decimal places
- Estimate total input + output tokens needed to complete the request
- For website meta edits, use a small estimate
- For page generation or major edits, use a larger estimate based on a full HTML/CSS page with 6-10 sections
`;





const generateFullPageHtmlCssPromptContract = `
Return VALID JSON ONLY:
{
  "html": "<BODY CONTENT ONLY>",
  "css": "FULL CSS"
  "pageSummary": "A Short (1-3 sentences) summary describing the page layout, style, and key sections."
}

If the user asks for a blank page, return empty HTML and CSS with a white background.

RULES:
- HTML must have ONE root wrapper: <main class="page">...</main>
- Do NOT include <html>, <head>, <body>, <script>
- No inline JS or script tags
- No code comments
- Use semantic HTML

CLASS NAMING:
- SUPER IMPORTANT: Every component must have ONE unique descriptive class based on their position in the hierarchy
- SUPER IMPORTANT: Children components should always have parent class name as part of their unique class name, example if parent class="hero-1-con1" then child class="hero-1-con1-btn"
- All classes MUST start with "k-"
- Use short structured names based on hierarchy
- NEVER EVER USE COMMONLY USED NAMES LIKE "cta" etc.
- NEVER EVER USE MORE THAN ONE CLASS FOR ONE COMPONENT. This -> class="con1 con1-btn" is strickly forbidden. JUST ONE CLASS IS REQUIRED.

Examples:
k-hero1
k-hero1-hd1
k-hero1-btn1
k-ctct1-frm1
k-ctct1-in1

ABBREVIATIONS:
sec = section
con = container
hd = heading
p = paragraph
btn = button
frm = form
in = input
img = image
...

CSS RULES:
- All selectors must start with ".page " except :root, html, and body.
- Keep CSS for each component grouped together

DESIGN:
- 4–5 sections per page
- Mobile-first responsive layout
- Navbar collapses to hamburger on mobile
- Modern UI with light animations
`;